<template>
  <div v-if="brand != null">
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Marka Düzenleme">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span>
                <strong>Not:</strong>
                Markayı düzenlemek için aşağıdaki alanları doldurunuz.
              </span>
            </div>
          </b-alert>
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            :to="`/catalog/brands?page=${page}`"
          >
            Marka Listesi
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="Marka Düzenleme Formu">
            <b-row>
              <b-col cols="12">
                <b-form-group label="Başlık" label-for="title">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true, max: chars.title }"
                    name="Başlık"
                  >
                    <b-form-input
                      id="title"
                      v-model="title"
                      placeholder="Başlık"
                      :state="errors.length > 0 ? false : null"
                      :class="title.length >= chars.title ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="title.length >= chars.title ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ title.length }}</span>
                      /
                      {{ chars.title }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <DragDropImage
                  v-if="brand != null"
                  ref="refCardLogo"
                  title="Logo Görsel"
                  :required="false"
                  :imageUrl="
                    brand.logo.web == null ? brand.logo.original : brand.logo.web
                  "
                  :width="1920"
                  :height="1080"
                  :wheel="false"
                  :movable="true"
                  :resizable="false"
                >
                </DragDropImage>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <DragDropImage
                  v-if="brand != null"
                  ref="refCardLogo2"
                  title="Logo2 Görsel"
                  :required="false"
                  :imageUrl="
                    brand.logo2.web == null ? brand.logo2.original : brand.logo2.web
                  "
                  :width="1920"
                  :height="1080"
                  :wheel="false"
                  :movable="true"
                  :resizable="false"
                >
                </DragDropImage>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <DragDropImage
                  v-if="brand != null"
                  ref="refCardLogo2White"
                  title="Logo2 Beyaz Görsel"
                  :required="false"
                  :imageUrl="brand.logo2.webWhite == null ? null : brand.logo2.webWhite"
                  :width="1920"
                  :height="1080"
                  :wheel="false"
                  :movable="true"
                  :resizable="false"
                >
                </DragDropImage>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <DragDropImage
                  v-if="brand != null"
                  ref="refCardTitleImages"
                  title="Başlık Görsel"
                  :required="false"
                  :imageUrl="
                    brand.titleImages.web == null
                      ? brand.titleImages.original
                      : brand.titleImages.web
                  "
                  :width="1920"
                  :height="1080"
                  :wheel="false"
                  :movable="true"
                  :resizable="false"
                >
                </DragDropImage>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="mt-5"></b-col>
              <b-col md="6" class="mt-5">
                <b-button
                  class="float-right mt-2"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-success"
                  @click="postConfirmText(0)"
                >
                  <b-spinner v-if="spinner === true && isDraft === 0" small />
                  {{ spinner === true && isDraft === 0 ? "Yayınlanıyor" : "Yayınla" }}
                </b-button>
                <b-button
                  class="float-right mt-2 mr-1"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-warning"
                  @click="postConfirmText(1)"
                >
                  <b-spinner v-if="spinner == true && isDraft == 1" small />
                  {{
                    spinner == true && isDraft == 1
                      ? "Taslağa Kaydediliyor"
                      : "Taslağa Kaydet"
                  }}
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import DragDropImage from "../../components/DragDropImage.vue";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BLink,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormFile,
  BCardText,
  BMediaBody,
  BFormInput,
  BFormGroup,
  BMediaAside,
  BInputGroup,
  BFormTextarea,
  BFormDatepicker,
  BFormTimepicker,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  max,
  digits,
  alphaDash,
  length,
} from "@validations";

import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    DragDropImage,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormTimepicker,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    max,
    digits,
    alphaDash,
    length,
    flatPickr,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      id: null,
      idParam: this.$route.params.idParam,
      page: this.$route.query.page ? this.$route.query.page : 1,
      targetLocale: this.$route.query.targetLocale,
      brand: null,
      title: "",
      isDraft: 0,
      spinner: false,
      chars: {
        title: 255,
      },
    };
  },

  methods: {
    postConfirmText(isDraft) {
      this.isDraft = isDraft;
      this.$swal({
        title: "Kayıt?",
        text: "Makayı güncellemek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit();
        }
      });
    },
    postSubmit() {
      this.$refs.rules.validate().then((success) => {
        if (success) {
          this.spinner = true;
          let formData = new FormData();

          formData.append("id", this.id);
          formData.append("title", this.title);
          formData.append("isDraft", this.isDraft);

          if (this.$refs.refCardLogo.image != null) {
            formData.append("logo", this.$refs.refCardLogo.image);
          }
          if (this.$refs.refCardLogo2.image != null) {
            formData.append("logo2", this.$refs.refCardLogo2.image);
          }
          if (this.$refs.refCardLogo2White.image != null) {
            formData.append("logo2White", this.$refs.refCardLogo2White.image);
          }
          if (this.$refs.refCardTitleImages.image != null) {
            formData.append("titleImages", this.$refs.refCardTitleImages.image);
          }

          endpoints
            .putCatalogBrands(formData, this.targetLocale, () => {})
            .then((data) => {
              this.spinner = false;
              this.$swal({
                icon: "success",
                title: "Kayıt başarılı!",
                text: "Marka güncellendi.",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              }).then((result) => {
                if (result.value) {
                  this.$router.push({
                    path: `/catalog/brands?page=${this.page}`,
                  });
                }
              });
            })
            .catch((err) => {
              this.spinner = false;
              console.log(err);
            });
        }
      });
    },
    getCatalogBrandsById() {
      endpoints
        .getCatalogBrandsById(this.idParam, this.targetLocale, () => {})
        .then((data) => {
          this.id = data.response.id;
          this.brand = data.response;
          this.title = data.response.title;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {},
  destroyed() {},
  mounted() {
    this.getCatalogBrandsById();
    localize("tr");
  },
  setup() {},
};
</script>
<style lang="css">
.ql-container {
  margin-top: 30px;
}

.ql-container,
.ql-editor {
  min-height: 300px !important;
  margin-bottom: 30px;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>
